/*
 * @Author: alex.dai
 * @Date: 2023-04-10 15:33:22
 * @LastEditors: alex.dai
 * @LastEditTime: 2023-04-20 11:06:11
 * @FilePath: /new-frontend/src/store/modules/recharge.js
 * @Description:
 */
// 权益管理
// import api from '../../api'
import _ from 'underscore'

const state = {
  rechargeStatus: [
    {
      value: 0,
      label: '充值中'
    },
    {
      value: 1,
      label: '充值成功'
    },
    {
      value: 2,
      label: '充值失败'
    },
    {
      value: 3,
      label: '未知'
    }
  ],
  rechargeType: [
    {
      value: 1,
      label: '手动充值'
    },
    {
      value: 2,
      label: '批量充值'
    },
    {
      value: 3,
      label: '接口充值'
    }
  ],
  rechargeTypeCarmi: [
    {
      value: 1,
      label: '手动购买'
    },
    {
      value: 2,
      label: '批量导入'
    },
    {
      value: 3,
      label: '接口调用'
    }
  ],
  nodeState: [
    {
      value: 0,
      label: '充值中',
      color: 'blue'
    },
    {
      value: 1,
      label: '成功',
      color: 'cyan'
    },
    {
      value: 2,
      label: '失败',
      color: 'red'
    },
    {
      value: 5,
      label: '待领取',
      color: 'blue'
    },
    {
      value: -1,
      label: '已核销',
      color: 'green'
    }
  ],
  notifyState: [
    {
      value: 0,
      label: '待核销',
      color: 'default'
    },
    {
      value: 1,
      label: '已核销',
      color: 'cyan'
    }
  ],
  reconciliationStatus: [
    {
      value: 0,
      label: '未进流水',
      color: 'default'
    },
    {
      value: 1,
      label: '待对账',
      color: 'blue'
    },
    {
      value: 2,
      label: '已对账待付款',
      color: 'cyan'
    },
    {
      value: 3,
      label: '付款完成',
      color: 'success'
    }]
}

const getters = {
  rechargeStatus: state => state.rechargeStatus,
  rechargeStatusByValue: (state) => {
    return (value) => {
      return _.find(state.rechargeStatus, item => {
        return item.value === value
      })
    }
  },
  rechargeType: state => state.rechargeType,
  rechargeMethodByValue: (state) => {
    return (value) => {
      return _.find(state.rechargeType, item => {
        return item.value === value
      })
    }
  },
  rechargeTypeCarmi: state => state.rechargeTypeCarmi,
  rechargeMethodCarmiByValue: (state) => {
    return (value) => {
      return _.find(state.rechargeTypeCarmi, item => {
        return item.value === value
      })
    }
  },
  nodeState: state => state.nodeState,
  notifyState: state => state.notifyState,
  reconciliationStatus: state => state.reconciliationStatus
}

const actions = {

}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
